import React, { useState,useEffect } from "react";
import "./CustomPackages.css";
import { Navigate } from "react-router-dom"; 
import { Col, Container, Row } from "react-bootstrap";
import { PackageList } from "../../Features/CustomPackages";
import Cookies from "js-cookie";


const CustomPackages = ({ url }) => {
    // Check if user cookie exists (simple example)
  // const hasUserCookie = document.cookie && document.cookie.length > 0;
  const hasUserCookie = Cookies.get("api_key") !=null && Cookies.get("api_secret") !=null;

  const [redirectToLogin, setRedirectToLogin] = useState(false);

  useEffect(() => {
    if (!hasUserCookie) {
      setRedirectToLogin(true);
    }
  }, [hasUserCookie]);

  // Redirect if not logged in


  // Add state for package data here
  const [packageData, setPackageData] = useState({
    packageName: "",
    countries: [],
    travelers: {
      adults: 1,
      children: 0,
      children_ages: [],
    },
    startDate: "",
    endDate: "",
  });


    if (redirectToLogin) {
    return <Navigate to="/login" replace />;
  }

  return (
    <Container className="packages-page-container">
      <Row>
        <Col
          style={{ position: "relative" }}
          className="tabs-content-container"
        >
          <div>
            {
              <PackageList
                packageData={packageData}
                setPackageData={setPackageData}
                url={url}
              />
            }
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default CustomPackages;
